import { changeLocale, SUPPORTED_LOCALES, useThemeStore, type ThemeMode } from '@sentinel/web-core';
import { Icon, type IconName } from '@sentinel/ui';
import { useTranslation } from 'react-i18next';

const THEMES: readonly { mode: ThemeMode; icon: IconName }[] = [
  { mode: 'auto', icon: 'auto' },
  { mode: 'light', icon: 'sun' },
  { mode: 'dark', icon: 'moon' },
];

/** Host of the page (a lock: the sign-in only ever travels over the secure origin), language
 *  and theme. Nobody is signed in yet, so both choices stay on this device. */
export function AccountsTopbar() {
  const { t, i18n } = useTranslation();
  const mode = useThemeStore((s) => s.mode);
  const setMode = useThemeStore((s) => s.setMode);
  return (
    <div className="acc-topbar">
      <span className="acc-chip host">
        <Icon name="lock" size={14} />
        <span className="mono">{window.location.host}</span>
      </span>
      <div className="acc-seg" role="group" aria-label={t('accounts.topbar.language')}>
        {SUPPORTED_LOCALES.map((locale) => (
          <button
            key={locale}
            type="button"
            aria-pressed={i18n.language === locale}
            onClick={() => void changeLocale(locale)}
          >
            {locale.toUpperCase()}
          </button>
        ))}
      </div>
      <div className="acc-seg" role="group" aria-label={t('accounts.topbar.theme')}>
        {THEMES.map(({ mode: option, icon }) => (
          <button
            key={option}
            type="button"
            aria-pressed={mode === option}
            title={t(`accounts.topbar.${option}`)}
            onClick={() => setMode(option)}
          >
            <Icon name={icon} size={14} />
            <span className="t-txt">{t(`accounts.topbar.${option}`)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
